// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2qv46","colBig":"styles_colBig__2Gmgq","colSmall":"styles_colSmall__txVyd"};